import React from 'react';
import { Repeat, Clock, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/ui/card';
import BackButton from '../../../components/admin/BackButton';

const AssistantAutomations = () => {
  const automations = [
    {
      title: "Daily Invoice Generation",
      description: "Automatically generate invoices daily at 9 AM",
      status: "planned",
      icon: Clock
    },
    {
      title: "Weekly Reports",
      description: "Send financial reports every Monday",
      status: "planned",
      icon: CheckCircle
    },
    {
      title: "Client Follow-ups",
      description: "Auto-send follow-up emails after 7 days",
      status: "planned",
      icon: Clock
    }
  ];

  return (
    <div>
      <BackButton />
      
      <div className="mb-8">
        <div className="flex items-center space-x-3">
          <div className="p-3 bg-purple-500 bg-opacity-10 rounded-lg">
            <Repeat className="h-6 w-6 text-purple-600" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-[#2B2D42]">Automations</h2>
            <p className="text-sm text-[#6C757D]">Automate repetitive tasks and workflows</p>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        {automations.map((automation, index) => {
          const Icon = automation.icon;
          return (
            <Card key={index}>
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div className="flex items-start space-x-3">
                    <div className="p-2 bg-purple-100 rounded-lg">
                      <Icon className="h-5 w-5 text-purple-600" />
                    </div>
                    <div>
                      <CardTitle className="text-lg">{automation.title}</CardTitle>
                      <CardDescription>{automation.description}</CardDescription>
                    </div>
                  </div>
                  <span className="px-3 py-1 text-xs bg-yellow-100 text-yellow-800 rounded-full">
                    {automation.status}
                  </span>
                </div>
              </CardHeader>
            </Card>
          );
        })}
      </div>

      <Card className="mt-8 bg-purple-50 border-purple-200">
        <CardContent className="pt-6">
          <p className="text-sm text-[#6C757D]">
            🔄 <strong>Automations</strong> will help you save time by automatically executing repetitive tasks. 
            This feature is under development.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AssistantAutomations;